import { __assign } from "tslib";
import { createAppSettingsApi } from './index';
import { createHttpTestKit } from '../../http/test-kit';
import { createAppCustomJsApiTestKit } from './custom-js/testkit';
import { createAppCustomCssApiTestKit } from './custom-css/testkit';
export var createAppSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAppSettingsApi('', fakeHttp);
    var testKit = {
        customJs: createAppCustomJsApiTestKit(),
        customCss: createAppCustomCssApiTestKit(),
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map